module.exports = __webpack_public_path__ + "static/media/GH.d9949341.svg";